import { Redirect, useParams } from "react-router-dom";

import { adminRoute } from "@/config/roles";
import { useCurrentUserId } from "@/lib/hooks/useCurrentUserId";
import type { UUID } from "@/core/types";

import { ProfileSidebar } from "../../(shared)/(profile)/components/ProfileSidebar";
import { UserProfile } from "../../(shared)/(profile)/UserProfile";

import { AdminCalendarPreferencesCard } from "./components/AdminCalendarPreferencesCard";
import { BasicInfoCard } from "./components/BasicInfoCard";
import { LcswPermissionOthers } from "./components/lcsw/LcswPermissionOthers";
import { useAdminProfileById } from "./api/queries/useAdminProfileById";

export function AdminProfileOthers() {
  const { adminId } = useParams<{ adminId: UUID }>();
  const currentUserId = useCurrentUserId();
  const { data: profileData, isLoading } = useAdminProfileById(adminId);

  // viewing own profile via the "others" route -> send to the editable self view
  if (adminId === currentUserId) return <Redirect to={`${adminRoute}/profile`} />;

  return (
    <UserProfile
      asideContent={profileData ? <ProfileSidebar profileData={profileData} /> : null}
      isLoading={isLoading || !profileData}
      renderMainContent={() =>
        profileData ? (
          <>
            <BasicInfoCard isReadOnly profileData={profileData} />
            <LcswPermissionOthers profileData={profileData} userId={adminId} />
            <AdminCalendarPreferencesCard isReadOnly preferences={profileData.preferences} />
          </>
        ) : null
      }
      title={profileData?.name ?? "Admin Profile"}
    />
  );
}
